import DynamicForm, { FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { useCreateDataPointValues, useGetDataPointValues } from 'api/hooks/useDataPointValues';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import DynamicFormWrapper from 'components/DynamicFormWrapper';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import {
  CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH,
  CONTINUE_ONLINE_MARIJUANA_PATH,
} from 'routes/constants';
import useSelector from 'store/useSelector';

import schema from './schema';
import { FormValues } from './types';

const marijuanaUseUrn = 'urn:pg:data-point:insured-risk-condition-marijuana';

const urns: Array<keyof FormValues> = [
  'urn:pg:data-point:insured-risk-condition-alcohol-treatment',
  'urn:pg:data-point:insured-risk-condition-alcohol-treatment-date',
  'urn:pg:data-point:insured-risk-condition-drinks-alcohol',
  'urn:pg:data-point:insured-risk-condition-drinks-alcohol-quantity-per-week',
  'urn:pg:data-point:insured-risk-condition-drug-treatment',
  'urn:pg:data-point:insured-risk-condition-drug-treatment-date',
  marijuanaUseUrn,
];

const SubstanceUse: React.FC = () => {
  const navigate = useNavigate();
  const activeUserUuid = useSelector((app) => app.activeUserUuid);

  const { createDataPointValuesFromInterview } = useCreateDataPointValues({
    onCompleted: (data) => {
      const marijuanaUse = !!data.find((dp) => dp.urn === marijuanaUseUrn)?.value;

      completedNavigatorStep(StepName.SUBSTANCE_USE, activeUserUuid);

      marijuanaUse
        ? navigate(`../${CONTINUE_ONLINE_MARIJUANA_PATH}`)
        : navigate(`../${CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH}`);
    },
  });

  const { data, loading } = useGetDataPointValues({ params: { urns } });

  const onSubmit = async (values: FormValuesOutput<FormValues>) => {
    await createDataPointValuesFromInterview(values, schema);
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent>
      <DynamicFormWrapper>
        <DynamicForm<FormValues>
          name="substance-use"
          schema={schema}
          onSubmit={onSubmit}
          initialValues={data?.dataPointValues}
        />
      </DynamicFormWrapper>
    </NavigatorContent>
  );
};

export default SubstanceUse;
